var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

// テスト
var _isTest = false;

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

const __layer = $('.st-Container').attr('data-layer');

//preload
import {preload} from "../include/module";
preload();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

$(window).on('resize load' , function() {
  if(windowW <= 1024){
    _isSP = true;
  } else {
    _isSP = false;
  };

  //リサイズ処理 ブレイクポイントを跨いだらリロード
  var nowWidth = window.innerWidth;
  if(prewidth !== nowWidth){
    if(prewidth < 1025) {
      if(nowWidth >= 1025){
        location.reload();
      }
    }else {
      if(nowWidth < 1025){
        location.reload();
      }
    }
  };
});

$(window).on('load' , function() {

  scrollCommonAnime();

  if( __layer == 'first') {
    showAbout();
  }else{
    charaSlide();
    playVoice();
  }

});

// ------------------------------------------------------------------------
// showAbout
// ----- BOTH
// ------------------------------------------------------------------------
const showAbout = () => {

  $('.artist_Production').on('click', function(){

    $('#about-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){

      // fadeIn
      $('#about-Stage').stop().fadeIn(400);
      $('#about-Box').addClass('show');
      $('#about-Box_Txt').addClass('show');
      return false;

    });

  });


  //close
  $('#about-Box_Close').on('click', function(){

    $('#about-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){

      $('#about-Stage').css({'display':'none'});
      $('#about-Box').removeClass('show');
      $('#about-Box_Txt').removeClass('show');
    });
  });

};


// ------------------------------------------------------------------------
// charaSlide
// ----- BOTH
// ------------------------------------------------------------------------
const charaSlide = () => {

  var artistImg = new Swiper('.artist_Img_Container', {
    loop: true,
    // allowTouchMove: false,//スワイプを可能にするかどうか。デフォルトではtrue。
    loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
    slidesPerView: 1,
    effect: 'fade',
    speed: 500,
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.artist_Img_Button-Next',
      prevEl: '.artist_Img_Button-Prev',
      hideOnClick: true,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,//前後の画像を読み込む
      loadPrevNextAmount: 1,
      loadOnTransitionStart: true//スライドアニメーション前にロード
    },
  });
};

// ------------------------------------------------------------------------
// playVoice
// ----- BOTH
// ------------------------------------------------------------------------
const playVoice = () => {
  let _isSound = false;

  $('.artist_Voice_Btn').on('click', function(){

    const dataVoice = $(this).attr('data-voice');
    const sound = document.getElementById(dataVoice);
    console.log(sound);

    if(!_isSound) {
      $(this).addClass('play');
      sound.currentTime = 0;
      sound.play();
      _isSound = true;

      sound.addEventListener("ended", ()=>{
        $(this).removeClass('play');
        _isSound = false;
      });

    }else {
      sound.pause();
      $(this).removeClass('play');
      _isSound = false;
    }

    return false ;

  });

};


// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  const targets = document.querySelectorAll(".sw-Ttl");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
  const scene = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: 1
    })
    .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
      // console.log("Scene entered.");
      $(target).addClass("is-animated");
      setTimeout(function(){
        $(target).children(".en").textyle(
          {
            duration : 500, //エフェクト時間(ミリ秒)
            delay : 40, //文字間のエフェクト間隔(ミリ秒)
            // easing : 'swing', //エフェクトのイージングパターン
            callback : function(){
              $(target).addClass("is-completed");
            }
          }
        );
      },300);
    })
    // .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  //　スクロールで発火系 その他
  const targetsItem = document.querySelectorAll(".js-scrollAnimation");
  const targetsItemArray = Array.prototype.slice.call(targetsItem); //Array
  targetsItemArray.forEach(targetsItem => {
    //シーンを作成
    new ScrollMagic.Scene({
        triggerElement: targetsItem,
        triggerHook: 1
    })
    .setClassToggle(targetsItem, "is-animated")
    .addTo(controller);
  });

};


// WEBPACK FOOTER //
// ./src/marginal4_v0/assets/js/artist/script.js